import { stripHTMLTags, pieLoader } from "utils";

export default function usppModal(selector, domain) {
  const modal = document.querySelector(selector);
  if (!modal)
    throw new Error(`USPP modal Error: Modal (${selector}) not found`);

  document.addEventListener("click", async (event) => {
    if (event.target.matches("*[data-uspp-id]")) {
      modal.showModal();

      const loadingTimer = setTimeout(() => {
        modal.innerHTML = modalScafold(
          modal.id,
          event.target.textContent,
          domain,
          `
          <p class="pie-message info --p --mt rail --spread --y-center">
            <span>${pie_i18n.PIE_JS_USPP_MODAL_LOADING_MSG}</span>
            ${pieLoader("lift-up").outerHTML}
          </p>
        `
        );
      }, 400);

      const requestUrl = getRequestUrl(domain, event.target);
      const { level, name, subject, section } = await getUsppContent(
        domain,
        event.target.dataset.usppId
      );

      clearTimeout(loadingTimer);

      if (!level) {
        return (modal.innerHTML = modalScafold(
          modal.id,
          event.target.textContent,
          domain,
          `
          <p class="pie-message error --p --mt">🚫 ${pie_i18n.PIE_JS_USPP_MODAL_ERROR_MSG}</p>
        `
        ));
      }

      modal.innerHTML = modalScafold(
        modal.id,
        event.target.textContent,
        domain,
        `
        <div class="scroll-content stack --gap-md --mt-sm">

          ${descriptionLabel(name, pie_i18n.PIE_JS_USPP_MODAL_CC_VERSION_LABEL)}

          <div class="rail bg-gray-lite --p-xs --px --rounded-lg --spread --y-center">
            <strong class="--ellipsis">${
              pie_i18n.PIE_JS_USPP_MODAL_SUBJECT_LABEL
            }</strong>
            <span class="chalk-font font-sm text-green --no-shrink">${subject}</span>
          </div>

          <div class="rail bg-gray-lite --p-xs --px --rounded-lg --spread --y-center">
            <strong class="--ellipsis">${
              pie_i18n.PIE_JS_USPP_MODAL_LEVEL_LABEL
            }</strong>
            <span class="chalk-font font-sm text-green --no-shrink">${level}</span>
          </div>

          <div class="rail bg-gray-lite --p-xs --px --rounded-lg --spread --y-center">
            <strong class="--ellipsis">${
              pie_i18n.PIE_JS_USPP_MODAL_SECTION_LABEL
            }</strong>
            <span class="chalk-font font-sm text-green --no-shrink">${section}</span>
          </div>
        </div>

        <a href="${requestUrl}" class="pie-button green chalk-font text-white --mt --stretch --text-center">
          <span class="--ellipsis">${
            pie_i18n.PIE_JS_USPP_MODAL_BUTTON_LABEL
          }</span>
        </a>
      `
      );

      // Redner MathML.
      window.MathJax && window.MathJax.typeset();
    }
  });
}

// ---- Helpers ----------------

function descriptionLabel(name, cc_label) {
  return cc_label
    ? `<div class="relative crop pie-message success --px --pt-sm --pb-md">
        <span>${name}</span>
        <span class="absolute --bottom-right font-xs bg-green --pt-xs --px-sm">${cc_label}</span>
      </div>`
    : `<div class="relative crop pie-message success --px --py-sm">
        <span>${name}</span>
      </div>`;
}

function modalScafold(id, header, domain, body) {
  return `
    <div class="stack --gap-sm">
      <div class="rail --spread">
        <p class="chalk-font font-xl text-green">${header}</p>
        <button onclick="${id}.close()">
          <svg class="icon sm" aria-hidden="true">
              <use href="${domain}/templates/pistacja/images/icons/icons.svg#ui-close"></use>
            </svg>
        </button>
      </div>
      ${body}
    </div>
  `;
}

function getRequestUrl(domain, target) {
  return `${domain}${pie_i18n.PIE_JS_USPP_MODAL_SEARCH_URL}?q=${target.textContent}`;
}

function getUsppContent(domain, id) {
  return fetch(`${domain}cli/getpppname.php?code=${id}`, {
    mode: "cors",
    method: "post",
    cache: "default",
  })
    .then((r) => r.json())
    .catch((e) => {
      console.error(e);
      return {};
    });
}
